<script setup lang="ts">
const { t } = useTexts();
const { isUserV2Enabled } = useFeatureFlagsJson();
const { initSmarticoError, isReadySmartico } = storeToRefs(useSmarticoInit());

useSeo({
  title: t('notifications.title'),
});

const loadComponent = computed(() => {
  return !initSmarticoError.value && isReadySmartico.value;
});
</script>

<template>
  <UserV2ScreenNotifications v-if="isUserV2Enabled" />
  <UserAccountPageLayout v-else>
    <div :class="$style.centerPage">
      <SmarticoAlertsAndLoader
        v-if="!loadComponent"
        :is-notification-page="true"
      />
      <SmarticoNotifications v-if="loadComponent" />
    </div>
  </UserAccountPageLayout>
</template>

<style module lang="scss">
.centerPage {
  @apply w-full min-h-[400px] flex flex-col items-center justify-center relative;
}
</style>
